import React from 'react';
import { MARQUEE_ITEMS } from '../mock';

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="marquee-wrap relative overflow-hidden bg-[#17130f] border-y border-[rgba(224,180,159,0.12)] py-7">
      <div className="marquee-track">
        {items.map((item, i) => (
          <div key={i} className="flex items-center shrink-0">
            <span className="font-serif-display italic text-3xl md:text-4xl text-[#e6ddd2] px-8">
              {item}
            </span>
            <span className="text-[#e0b49f] text-xl">✦</span>
          </div>
        ))}
      </div>
      {/* edge fades */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#17130f] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#17130f] to-transparent" />
    </div>
  );
}
